/**
 * 角色配置管理
 * 统一管理系统中的角色定义和权限组
 */

// 角色配置
export const ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  USER_OPERATION: 'USER_OPERATION',
  EMPLOYEE: 'EMPLOYEE',
  GUEST: 'GUEST',
  DATA_ANALYST: 'DATA_ANALYST', // 数据分析角色 - 用于访问设备激活数据看板
  CONTENT_MANAGER: 'CONTENT_MANAGER', // 内容管理角色 - 用于管理官方模型
} as const;

// 兼容旧系统的角色映射
export const LEGACY_ROLES = {
  YunYing: ROLES.USER_OPERATION,
} as const;

// 角色层级定义（目前未使用，保留以备将来权限比较使用）
export const ROLE_HIERARCHY = {
  [ROLES.SUPER_ADMIN]: 5,
  [ROLES.USER_OPERATION]: 4,
  [ROLES.DATA_ANALYST]: 3,
  [ROLES.CONTENT_MANAGER]: 3,
  [ROLES.EMPLOYEE]: 2,
  [ROLES.GUEST]: 1,
} as const;

// 权限组配置
export const PERMISSION_GROUPS = {
  ADMIN: [ROLES.SUPER_ADMIN],
  OPERATOR: [ROLES.USER_OPERATION, ROLES.SUPER_ADMIN],
  USER: [ROLES.EMPLOYEE, ROLES.USER_OPERATION, ROLES.SUPER_ADMIN],
  DATA_ANALYST: [ROLES.DATA_ANALYST, ROLES.SUPER_ADMIN],
  CONTENT_MANAGER: [ROLES.CONTENT_MANAGER, ROLES.SUPER_ADMIN],
} as const;

// 角色类型定义
export type RoleCode = (typeof ROLES)[keyof typeof ROLES];
export type PermissionGroup = keyof typeof PERMISSION_GROUPS;
